import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import '../../styles/tabs.css';
import StatementsTable from '../Tables/StatementsTable';

function StatementsModal({
  closeModal,
  options,
  selectedWeek,
  fleets,
  midMultiSelectStyles,
  selectStyles,
  data,
  handleGeneratePdf,
  selectedRows,
  setSelectedRows,
  modalLoading
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [selectedFleet, setSelectedFleet] = useState(null);

  const formattedOptions = options.map((option) => ({
    value: option.id,
    label: option.name,
  }));

  const formattedFleets = data.map((fleet) => ({
    label: fleet.fleet_name,
    value: fleet.fleet_id,
  }));

  const handleDriverSelect = (selectedOptions) => {
    setSelectedDrivers(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleFleetSelect = (selectedOption) => {
    setSelectedFleet(selectedOption ? selectedOption.value : null);
  };

  // Filter data based on selected drivers, fleet, and search query
  const filteredData = data
    .filter((driver) =>
      selectedDrivers.length ? selectedDrivers.includes(driver.account_id) : true
    )
    .filter((driver) =>
      selectedFleet ? driver.fleet_id === selectedFleet : true
    )
    .filter((driver) =>
      Object.values(driver).some((value) =>
        value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    );

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-40">
        <div
          className="fixed inset-0 bg-black opacity-50"
          onClick={closeModal}
        />

        <div
          className="bg-white w-1/2 rounded-lg shadow-lg z-10 relative"
          style={{ height: '700px' }}
        >
          {modalLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50 z-50">
              <div className="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            </div>
          )}
          <div className="flex flex-row justify-end p-2">
            <button
              onClick={closeModal}
              className="absolute right-4 top-4 p-1 border border-gray-300 rounded-full hover:bg-gray-50">
              <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 4L4 12M4 4L12 12"
                    stroke="#6B7280"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
            </button>
          </div>

          <div className="p-2 pt-3 pb-1 flex flex-col">
            <h2
              style={{ color: '#6E6C71' }}
              className="text-xl font-medium mb-4">
              Driver Statements
            </h2>

            <div className="flex flex-col p-1 my-2 rounded-lg">
              <p className="text-gray-600 mb-1">Select Filters</p>
              {/* <div className="w-full flex flex-row space-x-3">
                <div className="w-1/2">
                  <Select
                    placeholder="[Fleet Name]"
                    isMulti={false}
                    options={formattedFleets}
                    onChange={(option) =>
                      setSelectedFleet(option ? option.value : null)
                    }
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={midMultiSelectStyles}
                  />
                </div>
                <div className="w-1/2">
                  <Select
                    isMulti
                    placeholder="[Driver Name]"
                    options={formattedOptions}
                    onChange={handleDriverSelect} // Driver filter handler
                    styles={midMultiSelectStyles}
                  />
                </div>
              </div> */}
            </div>
            <div className="relative w-64 mb-4">
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full h-10 pl-4 pr-10 text-sm bg-white border border-gray-200 rounded-full"
              />
              <div className="absolute inset-y-0 right-0 flex items-center mr-2 pr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 21l-4.35-4.35M16.65 16.65A7.5 7.5 0 1116.65 2a7.5 7.5 0 010 15z"
                  />
                </svg>
              </div>
            </div>
            <div
              className="overflow-y-auto px-4 scrollbar"
              style={{ maxHeight: '370px' }}>
              <StatementsTable data={filteredData} searchQuery={searchQuery} onSelectionChange={setSelectedRows} />
            </div>
            <div className="flex flex-row justify-end mt-4 px-4 pt-4 pb-0 space-x-1">
            
              <button
                onClick={handleGeneratePdf}
                disabled={selectedRows.length === 0}
                className="px-6 py-2 bg-purple-600 text-white rounded text-sm hover:bg-purple-800"
              >
                Download Statements
              </button>
              <button disabled={true} className="cursor-not-allowed px-6 py-2 bg-gray-400 rounded text-sm text-gray-700">
                Submit Statements
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StatementsModal;
